module.exports = __webpack_public_path__ + "static/media/white-play.20d409ee.svg";